import React, { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Alert, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';

import { Error } from 'common/types/disco/calculateVolumes';

type Props = {
  errors?: Error[];
  severity: AlertColor;
};

export const ErrorsAlert = ({ errors = [], severity }: Props) => {
  const [open, setOpen] = useState(true);
  if (errors.length === 0) {
    return null;
  }
  return (
    <Alert
      severity={severity}
      sx={{ alignItems: 'center' }}
      action={
        <IconButton onClick={() => setOpen(prev => !prev)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      }
    >
      <AlertTitle sx={{ textTransform: 'capitalize', paddingTop: 3 }}>
        {severity}
      </AlertTitle>
      <Collapse in={open}>
        {errors.map(e => (
          <li key={e.message}>{e.message}</li>
        ))}
      </Collapse>
    </Alert>
  );
};
